"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var countries = [{
  region: 'AT',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#f0f0f0",
    d: "M496.077 345.043C506.368 317.311 512 287.314 512 256s-5.632-61.309-15.923-89.043L256 144.696 15.923 166.957C5.633 194.691 0 224.686 0 256s5.633 61.311 15.923 89.043L256 367.304l240.077-22.261z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#d80027",
    d: "M256 512c110.07 0 203.906-69.472 240.076-166.957H15.922C52.094 442.528 145.928 512 256 512zm0-512C145.928 0 52.094 69.472 15.922 166.957h480.155C459.906 69.472 366.07 0 256 0z"
  }))
}, {
  region: 'BG',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: 'new 0 0 512 512'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      fill: '#D62612'
    },
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#00966E'
    },
    d: "M256,0C114.616,0,0,114.616,0,256c0,31.314,5.633,61.311,15.923,89.043h480.155  C506.368,317.311,512,287.314,512,256C512,114.616,397.384,0,256,0z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#ffffff'
    },
    d: "M256,0C145.929,0,52.094,69.472,15.923,166.957h480.155C459.906,69.472,366.071,0,256,0z"
  })))
}, {
  region: 'CZ',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#F0F0F0",
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#D80027",
    d: "M233.739,256c0,0-158.609,181.055-158.759,181.019C121.306,483.346,185.307,512,256,512 c141.384,0,256-114.616,256-256H233.739z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#0052B4",
    d: "M74.98,74.98c-99.974,99.974-99.974,262.065,0,362.04C116.293,395.707,156.026,355.974,256,256 L74.98,74.98z"
  }))
}, {
  region: 'DE',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.68 473.68",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#FFFFFF",
    cx: "236.85",
    cy: "236.85",
    r: "236.83"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#D32027",
    d: "M460.14,157.874H314.218c6.335,50.593,6.376,106.339,0.12,156.995h146.116 c8.526-24.438,13.219-50.682,13.219-78.026C473.677,209.139,468.875,182.573,460.14,157.874z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#0B0B0B",
    d: "M314.218,157.874H460.14c-0.026-0.075-0.049-0.138-0.075-0.206 C429.752,72.2,351.785,9.319,258.105,0.972C294.357,20.844,304.944,83.804,314.218,157.874z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F3C515",
    d: "M258.109,472.697c93.848-8.362,171.927-71.46,202.12-157.156c0.079-0.228,0.146-0.452,0.228-0.673 h-146.12C305.142,389.338,294.51,452.743,258.109,472.697z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#DB2727",
    d: "M0,236.842c0,27.348,4.693,53.588,13.219,78.026h313.313c6.256-50.66,6.215-106.402-0.12-156.995 H13.534C4.798,182.573,0,209.139,0,236.842z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#151515",
    d: "M13.605,157.668c-0.026,0.067-0.049,0.131-0.075,0.206h312.883 c-9.274-74.07-32.056-137.029-68.303-156.901C251.097,0.352,244.007,0,236.835,0C133.806,0,46.184,65.802,13.605,157.668z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F8D12E",
    d: "M326.532,314.868H13.219c0.079,0.221,0.15,0.445,0.228,0.673 c32.452,92.102,120.19,158.135,223.387,158.135c7.173,0,14.263-0.352,21.274-0.98C294.51,452.743,317.336,389.338,326.532,314.868z"
  }))
}, {
  region: 'DK',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    height: "200px",
    width: "200px",
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: "0"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/_react.default.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      fill: '#F0F0F0'
    },
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M200.349,222.609h309.484C493.47,97.002,386.067,0,256,0c-19.115,0-37.732,2.113-55.652,6.085 v216.524H200.349z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M133.565,222.608V31.127C63.272,69.481,12.95,139.832,2.167,222.609h131.398V222.608z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M133.564,289.391H2.167c10.783,82.777,61.105,153.128,131.398,191.481L133.564,289.391 L133.564,289.391z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M200.348,289.392v216.523C218.268,509.887,236.885,512,256,512 c130.067,0,237.47-97.002,253.833-222.609H200.348V289.392z"
  }))))
}, {
  region: 'FR',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#f0f0f0",
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#EC1920",
    d: "M512 256c0-110.071-69.472-203.906-166.957-240.077v480.155C442.528 459.906 512 366.071 512 256z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#051440",
    d: "M0 256c0 110.071 69.473 203.906 166.957 240.077V15.923C69.473 52.094 0 145.929 0 256z"
  }))
}, {
  region: 'GR',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: 'new 0 0 512 512'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      fill: '#F0F0F0'
    },
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#338AF3'
    },
    d: "M256,189.217h247.181c-6.419-23.814-16.175-46.255-28.755-66.783H256V189.217z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#338AF3'
    },
    d: "M96.643,456.348h318.713c23.363-18.608,43.399-41.21,59.069-66.783H37.574 C53.245,415.137,73.281,437.74,96.643,456.348z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#338AF3'
    },
    d: "M89.043,61.939c-20.126,17.331-37.525,37.74-51.469,60.496h51.469V61.939z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#338AF3'
    },
    d: "M256,256c0-26.076,0-47.899,0-66.783H155.826V256H89.043v-66.783H8.819 C3.08,210.511,0,232.893,0,256s3.08,45.489,8.819,66.783h494.363C508.92,301.489,512,279.107,512,256H256z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#338AF3'
    },
    d: "M256,0c-35.549,0-69.404,7.253-100.174,20.348v102.087H256c0-23.312,0-43.139,0-66.783h159.357 C371.626,20.824,316.249,0,256,0z"
  })))
}, {
  region: 'HR',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: 'new 0 0 512 512'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#F0F0F0'
    },
    d: "M512,256c0-31.314-5.633-61.311-15.923-89.043L256,155.826l-240.077,11.13 C5.633,194.689,0,224.686,0,256s5.633,61.311,15.923,89.043L256,356.174l240.077-11.13C506.367,317.311,512,287.314,512,256z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#0052B4'
    },
    d: "M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M15.923,166.957h480.155C459.906,69.472,366.071,0,256,0S52.094,69.472,15.923,166.957z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("polygon", {
    style: {
      fill: '#338AF3'
    },
    points: "322.783,178.088 278.261,178.088 285.682,122.435 315.362,100.174 345.043,122.435 345.043,166.957 \t"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    style: {
      fill: '#338AF3'
    },
    points: "189.217,178.088 233.739,178.088 226.318,122.435 196.637,100.174 166.957,122.435 166.957,166.957 \t"
  })), /*#__PURE__*/_react.default.createElement("polygon", {
    style: {
      fill: '#0052B4'
    },
    points: "285.682,178.088 226.318,178.088 226.318,122.435 256,100.174 285.682,122.435 "
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#F0F0F0'
    },
    d: "M166.957,166.958v122.434c0,29.153,14.082,55.079,35.802,71.332l15.583-3.899l19.664,19.782 c5.815,1.198,11.832,1.829,17.995,1.829c6.13,0,12.117-0.623,17.901-1.809l22.447-18.69l12.892,2.751 c21.711-16.252,35.803-42.151,35.803-71.296V166.958H166.957z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("rect", {
    x: "166.957",
    y: "166.957",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "238.191",
    y: "166.957",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "309.426",
    y: "166.957",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "202.574",
    y: "202.574",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "273.809",
    y: "202.574",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "166.957",
    y: "238.18",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "202.574",
    y: "273.798",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "238.191",
    y: "238.18",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "309.426",
    y: "238.18",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "273.809",
    y: "273.798",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "238.191",
    y: "309.415",
    style: {
      fill: '#D80027'
    },
    width: "35.617",
    height: "35.617"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M202.574,309.418h-33.319c3.056,13.24,9.064,25.355,17.302,35.617h16.017V309.418z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M309.426,345.036h16.016c8.24-10.262,14.246-22.378,17.302-35.617h-33.318V345.036z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M202.574,345.036v15.541c10.359,7.795,22.465,13.384,35.617,16.066v-31.607H202.574z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M273.809,345.036v31.607c13.153-2.68,25.258-8.271,35.617-16.066v-15.541H273.809z"
  })))
}, {
  region: 'HU',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F0F0F0",
    d: "M15.923,166.957C5.633,194.691,0,224.686,0,256s5.633,61.311,15.923,89.043L256,367.304 l240.077-22.261C506.367,317.311,512,287.314,512,256s-5.633-61.309-15.923-89.043L256,144.696L15.923,166.957z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#D80027",
    d: "M256,0C145.93,0,52.094,69.472,15.924,166.957h480.155C459.906,69.472,366.072,0,256,0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#6DA544",
    d: "M256,512c110.072,0,203.906-69.472,240.078-166.957H15.924C52.094,442.528,145.93,512,256,512z"
  }))
}, {
  region: 'IT',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#f0f0f0",
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#CD212A",
    d: "M512 256c0-110.071-69.472-203.906-166.957-240.077v480.155C442.528 459.906 512 366.071 512 256z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#008C45",
    d: "M0 256c0 110.071 69.472 203.906 166.957 240.077V15.923C69.472 52.094 0 145.929 0 256z"
  }))
}, {
  region: 'PL',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#F0F0F0",
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#D80027",
    d: "M512,256c0,141.384-114.616,256-256,256S0,397.384,0,256"
  }))
}, {
  region: 'RO',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512"
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: "#ffda44",
    d: "M167 0h178l25.9 252.3L345 512H167l-29.8-253.4z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#0052b4",
    d: "M0 0h167v512H0z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#d80027",
    d: "M345 0h167v512H345z"
  })))
}, {
  region: 'RS',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    version: "1.1",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: 'new 0 0 512 512'
    },
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    style: {
      fill: '#F0F0F0'
    },
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#0052B4'
    },
    d: "M256,0C114.616,0,0,114.616,0,256c0,31.314,5.633,61.311,15.923,89.043h480.155  C506.368,317.311,512,287.314,512,256C512,114.616,397.384,0,256,0z"
  }), /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    style: {
      fill: '#D80027'
    },
    d: "M256,0C145.929,0,52.094,69.472,15.923,166.957h480.155C459.906,69.472,366.071,0,256,0z"
  })))
}, {
  region: 'SI',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    space: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#F0F0F0",
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#0052B4",
    d: "M496.077,166.957H222.609v-66.783H89.043v66.783h-73.12C5.633,194.689,0,224.686,0,256 s5.633,61.31,15.923,89.043L256,367.304l240.077-22.261C506.367,317.31,512,287.314,512,256S506.367,194.689,496.077,166.957z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#D80027",
    d: "M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F0F0F0",
    d: "M89.043,166.957v22.26c0,51.121,66.783,66.784,66.783,66.784s66.783-15.663,66.783-66.784v-22.26 l-22.261,22.261l-44.522-33.391l-44.522,33.391L89.043,166.957z"
  }))
}, {
  region: 'SK',
  icon: /*#__PURE__*/_react.default.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    fill: "#F0F0F0",
    cx: "256",
    cy: "256",
    r: "256"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#0052B4",
    d: "M256,512c141.384,0,256-114.616,256-256c0-31.314-5.632-61.311-15.923-89.043H15.923 C5.633,194.689,0,224.686,0,256C0,397.384,114.616,512,256,512z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#D80027",
    d: "M256,512c110.071,0,203.906-69.472,240.077-166.957H15.923C52.094,442.528,145.929,512,256,512z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#F0F0F0",
    d: "M66.198,144.696v127.706c0,72.644,94.901,94.903,94.901,94.903s94.9-22.259,94.9-94.903V144.696 H66.198z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#D80027",
    d: "M88.459,144.696v127.706c0,8.528,1.894,16.582,5.646,24.133c37.234,0,92.886,0,133.987,0 c3.752-7.55,5.646-15.605,5.646-24.133V144.696H88.459z"
  }), /*#__PURE__*/_react.default.createElement("polygon", {
    fill: "#F0F0F0",
    points: "205.62,233.739 172.23,233.739 172.23,211.478 194.491,211.478 194.491,189.217 172.23,189.217 172.23,166.957 149.969,166.957 149.969,189.217 127.709,189.217 127.709,211.478 149.969,211.478 149.969,233.739 116.577,233.739 116.577,256 149.969,256 149.969,278.261 172.23,278.261 172.23,256 205.62,256 "
  }), /*#__PURE__*/_react.default.createElement("path", {
    fill: "#0052B4",
    d: "M124.471,327.61c14.345,9.015,29.083,14.249,36.628,16.577c7.545-2.327,22.283-7.562,36.628-16.577 c14.466-9.092,24.607-19.49,30.365-31.075c-6.351-4.493-14.1-7.143-22.471-7.143c-3.048,0-6.009,0.361-8.856,1.024 c-6.033-13.708-19.728-23.285-35.665-23.285s-29.633,9.577-35.665,23.285c-2.847-0.663-5.809-1.024-8.856-1.024 c-8.371,0-16.12,2.65-22.471,7.143C99.863,308.119,110.004,318.517,124.471,327.61z"
  }))
}];

var useCountriesFlag = function useCountriesFlag() {
  return countries;
};

var _default = useCountriesFlag;
exports.default = _default;